import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "demand-day-input-group" };
import DemandDayInput from "./DemandDayInput.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DemandDayInputGroup',
    props: {
        date: {},
        variants: {},
        now: {},
        hoveredVariant: {},
        customerDisabled: { type: Boolean }
    },
    emits: ['hover', 'variantQuantityChange'],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        function onVariantQuantityChange(variant, quantity) {
            emit('variantQuantityChange', variant, quantity);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "demand-day-input-group__title" }, " ", -1)),
                _cache[1] || (_cache[1] = _createTextVNode()),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.variants, (variant) => {
                    return (_openBlock(), _createBlock(DemandDayInput, {
                        key: variant.variant.id,
                        variant: variant,
                        date: __props.date,
                        now: __props.now,
                        "customer-disabled": __props.customerDisabled,
                        onQuantityChange: ($event) => (onVariantQuantityChange(variant.variant, $event)),
                        onMouseover: ($event) => (emit('hover', variant)),
                        class: _normalizeClass(["demand-day-input-group__article", { 'demand-day-input-group__article--hover': variant === __props.hoveredVariant }])
                    }, null, 8, ["variant", "date", "now", "customer-disabled", "onQuantityChange", "onMouseover", "class"]));
                }), 128))
            ]));
        };
    }
});
